import { render, staticRenderFns } from "./DriverGroupData.vue?vue&type=template&id=5d885764&scoped=true"
import script from "./DriverGroupData.vue?vue&type=script&lang=js"
export * from "./DriverGroupData.vue?vue&type=script&lang=js"
import style0 from "./DriverGroupData.vue?vue&type=style&index=0&id=5d885764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d885764",
  null
  
)

export default component.exports